export class VisibilityTracker {
  private observer: IntersectionObserver
  private callbacks: Map<Element, (visible: boolean) => void> = new Map()

  constructor(root?: HTMLElement) {
    this.observer = new IntersectionObserver(
      (entries) => {
        this.handleIntersect(entries)
      },
      { root }
    )
  }

  public observe(element: Element, callback: (visible: boolean) => void): void {
    this.callbacks.set(element, callback)
    this.observer.observe(element)
  }

  public unobserve(element: Element): void {
    this.callbacks.delete(element)
    this.observer.unobserve(element)
  }

  private handleIntersect(entries: IntersectionObserverEntry[]): void {
    entries.forEach((entry) => {
      const callback = this.callbacks.get(entry.target)
      if (callback) callback(entry.isIntersecting)
    })
  }
}
